<template>
    <div class="container">
        <div class="row">
            <div class="six columns">
                <p></p>
                <p class="hello" style="font-size:2em; line-height: 1.5em; font-weight: 300;">Hallo, mein Name ist Nikolai M&uuml;ller.</p>
                <p >Seit 1992 entwickle ich Software für Kunden in verschiedenen Branchen, dabei sind Internet Appliaktionen mein Schwerpunkt.</p>
                <img src="../../assets/klein-niki-800px.png" class="img-klein-niki">
                <div>
                    <i style="font-size:12pt;">Hartnäckig, kreativ, hoch konzentriert und mit viel Elan, finde ich selbst für komplexeste Probleme immer eine intelligente Lösung!</i>
                </div>
            </div>

            <div class="six columns" style="padding: 5.6% 0;">
                <br><p style="font-size:2em; line-height: 1.5em; font-weight: 300;">&nbsp;</p>
                <p>Sie finden mich auch hier:</p>
                <table>
                    <tr>
                        <td>Xing:</td><td>&nbsp;</td>
                        <td>
                            <a href="https://www.xing.com/profile/Nikolai_Mueller7"
                                target="_blank"
                                rel="me"
                                title="Profil von Nikolai Müller auf www.xing.com"
                                >Profil<!-- <img src="https://www.xing.com/img/buttons/1_de_btn.gif" width="85" height="23" alt="Nikolai Müller">--></a><!-- *) -->
                        </td>
                    </tr>
                    <tr>
                        <td>Arbeitsprobe</td>
                        <td></td>
                        <td><a href="https://github.com/nikolaimueller" target="_blank" title="https://github.com/nikolaimueller">GitHub</a></td>
                    </tr>
                    <tr>
                        <td>Meine Neue:</td>
                        <td></td>
                        <td>
                            <a href="https://www.nikim.eu"
                                target="www-nikim-eu"
                                title="Meine neue Homepage (https://www.nikim.eu)"
                                >www.nikim.<b>eu</b></a>
                        </td>
                    </tr>
                </table>
                <!--
                <p>&nbsp; </p>
                <p><span class="link-color">*)</span> Cookie-Mania oder wo sind die "hübschen" Schaltflächen auf meine Xing und Freelancermap Profile geblieben?</p>
                <p>Ich glaube einfach viel zu sehr an "Das Gute" im Menschen - und darum war ich viel zu wenig argwöhnisch, als ich diese bunten Images von Xing und Freelancermap hier eingebunden hatte.</p>
                <p>Erst hinterher bemerkte ich, was für Cookie-Schleudern diese Bildchen eigentlich waren. - Sorry, ausgerechnet ich, ich hätte es nun wirklich besser wissen müssen!</p>
                <p><code>https://www.freelancermap.de/images/widgets/button/MeinProfil.png</code></p>
                <p><code>https://www.xing.com/img/buttons/1_de_btn.gif</code></p>
                -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageHome',
    data () {
        return {
            windowWidth: window.innerWidth
        }
    }
}
</script>

<style scoped>
.nikim-bold {
    font-weight: 300;
    font-size: 2rem;
}

/* Skeleton media queries:   http://getskeleton.com/#queries
    Desktop HD: 1200px  @media (min-width: 1200px) {}
    Desktop:    1000px  @media (min-width: 1000px) {}
    Tablet:      750px  @media (min-width: 750px) {}
    Phablet:     550px  @media (min-width: 550px) {}
    Mobile:      400px  @media (min-width: 400px) {}
--------------------------------------------------------- */
/* Larger than mobile */
@media (max-width: 400px) {
    .img-klein-niki { width: 170px; height: auto; border-radius: 4px; }
}

@media (min-width: 400px) {
    .img-klein-niki { width: 170px; height: auto; border-radius: 4px;
    }
}

/* Larger than phablet */
@media (min-width: 550px) {
    .img-klein-niki { width: 195px; height: auto; border-radius: 4px; }
}

/* Larger than tablet */
@media (min-width: 750px) {
    .img-klein-niki { width: 230px; height:auto; border-radius: 4px; }
}

/* Larger than desktop */
@media (min-width: 1000px) {
    .img-klein-niki { width: 300px; height:auto; border-radius: 4px; }
}

/* Larger than Desktop HD */
@media (min-width: 1200px) {
    .img-klein-niki { width: 320px; height:auto; border-radius: 4px; }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/PageHome.vue